// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amy-top-nav {
  display: initial !important;
}

/* preload.css */
.preload-image {
  content: url("content/images/logos/reachamy-logo.webp");
}

body {
  padding-right: 0px !important;
  overflow-y: hidden !important;
}

.borderRadius {
  border-radius: 55px !important;
}

.width {
  width: 82%;
}

@media only screen and (max-width: 600px) {
  .amy-top-nav {
    display: inherit !important;
  }
}
@media only screen and (max-width: 768px) {
  .filter-response {
    display: none;
  }
}
@media only screen and (min-width: 768px) {
  .screen-space {
    padding-right: 4%;
  }
}
.css-dgyrx0-MuiPaper-root-MuiAppBar-root {
  background-color: #f2f2fa;
  padding-right: unset !important;
}

.css-h5hoeg-MuiPaper-root-MuiAppBar-root {
  background-color: #1f1f26;
  padding-right: unset !important;
}

header.MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation0.MuiAppBar-root.MuiAppBar-colorPrimary.MuiAppBar-positionFixed.mui-fixed.css-xd8hqh-MuiPaper-root-MuiAppBar-root {
  padding-right: 0px !important;
}

.MuiDrawer-paper {
  border: none !important;
}

.fixed-button {
  position: fixed;
  bottom: 20px; /* Adjust this value to change the distance from the bottom */
  right: 20px; /* Adjust this value to change the distance from the right */
  z-index: 9999; /* Ensure the button appears above other elements */
  color: #fff;
  padding: 15px 20px;
  border-radius: 50%;
  cursor: pointer;
}

.fixed-img {
  position: fixed;
  top: 80px;
}

.css-1vrhpky,
.css-1fo85kc {
  overflow: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/layout/common-layout.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEA,gBAAA;AACA;EACE,uDAAA;AACF;;AAEA;EACE,6BAAA;EACA,6BAAA;AACF;;AACA;EACE,8BAAA;AAEF;;AAAA;EACE,UAAA;AAGF;;AAAA;EACE;IACE,2BAAA;EAGF;AACF;AADA;EACE;IACE,aAAA;EAGF;AACF;AADA;EACE;IACE,iBAAA;EAGF;AACF;AAAA;EACE,yBAAA;EACA,+BAAA;AAEF;;AAAA;EACE,yBAAA;EACA,+BAAA;AAGF;;AADA;EACE,6BAAA;AAIF;;AAFA;EACE,uBAAA;AAKF;;AAHA;EACE,eAAA;EACA,YAAA,EAAA,6DAAA;EACA,WAAA,EAAA,4DAAA;EACA,aAAA,EAAA,mDAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAMF;;AAMA;EACE,eAAA;EACA,SAAA;AAHF;;AAKA;;EAEE,2BAAA;AAFF","sourcesContent":[".amy-top-nav {\n  display: initial !important;\n}\n\n/* preload.css */\n.preload-image {\n  content: url('content/images/logos/reachamy-logo.webp');\n}\n\nbody {\n  padding-right: 0px !important;\n  overflow-y: hidden !important;\n}\n.borderRadius {\n  border-radius: 55px !important;\n}\n.width {\n  width: 82%;\n}\n\n@media only screen and (max-width: 600px) {\n  .amy-top-nav {\n    display: inherit !important;\n  }\n}\n@media only screen and (max-width: 768px) {\n  .filter-response {\n    display: none;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .screen-space {\n    padding-right: 4%;\n  }\n}\n\n.css-dgyrx0-MuiPaper-root-MuiAppBar-root {\n  background-color: #f2f2fa;\n  padding-right: unset !important;\n}\n.css-h5hoeg-MuiPaper-root-MuiAppBar-root {\n  background-color: #1f1f26;\n  padding-right: unset !important;\n}\nheader.MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation0.MuiAppBar-root.MuiAppBar-colorPrimary.MuiAppBar-positionFixed.mui-fixed.css-xd8hqh-MuiPaper-root-MuiAppBar-root {\n  padding-right: 0px !important;\n}\n.MuiDrawer-paper {\n  border: none !important;\n}\n.fixed-button {\n  position: fixed;\n  bottom: 20px; /* Adjust this value to change the distance from the bottom */\n  right: 20px; /* Adjust this value to change the distance from the right */\n  z-index: 9999; /* Ensure the button appears above other elements */\n  color: #fff;\n  padding: 15px 20px;\n  border-radius: 50%;\n  cursor: pointer;\n}\n// .fixed-column {\n//   position: fixed;\n//   top: 70px;\n//   right: 0;\n//   text-align: center;\n// }\n// .col-md-4 {\n//   flex: 0 0 auto;\n//   width: 29.333333% !important;\n// }\n.fixed-img {\n  position: fixed;\n  top: 80px;\n}\n.css-1vrhpky,\n.css-1fo85kc {\n  overflow: hidden !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
